<template>
  <div class="factoring-buildProject-container">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="project-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        :summary-method="summaryMethod"
        @search-reset="searchReset"
        @refresh-change="queryTableData"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @selection-change="selectionChange"
      >

        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="saveData(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
            <a-icon type="filter" /> 高级筛选
          </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click.stop="handleAdd()"
            v-if="permission.buildProject_add"
            >项目立项
          </el-button>
          <el-button
            type="primary"
            size="small"
            icon="el-icon-edit"
            plain
            v-if="permission.buildProject_edit"
            @click.stop="handleEdit()"
            >编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click.stop="handleDelete()"
            v-if="permission.buildProject_delete"
            >删除
          </el-button>
          <el-button
            size="small"
            icon="el-icon-download"
            @click="exportShow"
          >导出数据
          </el-button>
        </template>

        <template slot="name" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">{{row.name}}</div>
        </template>
      </avue-crud>
    </div>

    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="filterConfig"
              ref="formScreen"
              v-model="searchForm"
              @submit="filterSearch"
              @reset-change="searchResetScreen"
            >
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>

    <el-dialog
      :close-on-click-modal="false"
      title="项目立项"
      :visible.sync="buildVisible"
      width="40%"
    >
      <div class="addForm">
        <avue-form
          ref="basicInfo"
          v-model="addFormData"
          :option="addFormConfig"
        >
          <template #name>
            <!-- 存在绑定ID时不可更改项目 -->
            <CommonSelect
              :clearable="false"
              bindLabel="name"
              bindKey="id"
              dataUrl="bl/blprojectinfo/page"
              methods="get"
              dataMethod="params"
              searchKey="name"
              :initParam="initParam"
              :bindId="addFormData.projectInfoId?addFormData.projectInfoId:''"
              @handleChange="setProjectInfo"
            />
          </template>        
        </avue-form>
      </div>
    </el-dialog>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <SelectDepartment
      ref="selectdepartment"
      :checkdepartment="checkdepartment"
      :isOnly="true"
      @setDepartment="setDepartment"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import TagsCloud from "@/components/TagsCloud/TagsCloud";
// import { mapGetters } from "vuex";
import { downLoadTemplate } from "@/router/downLoadTem";
import { factoringTableConfig, factoringFilterConfig } from './formConfig'
import { getFactoringList, deleteFactoring } from '@/api/factoring/factoring'
import SelectPerson from "@/components/SelectPersonnel/person";
import CommonSelect from "@/components/commonSelect/commonSelect"
import SelectDepartment from "@/components/SelectDepartment/department";
import ExportData from "@/components/exportData/exportData";
import { mapGetters } from "vuex";
import workFlow from '@/mixins/workFlow'
import { floatAdd } from "@/util/util";
import moment from "moment";
export default {
  name:'FactoringProjectBuild',
  mixins: [workFlow],
  data() {
    return {
      initParam: { listScene: 'lx' },      
      buildVisible: false,
      addFormData: {},
      addFormConfig: {
        labelWidth: 130,
        emptyBtn: false,
        submitBtn: false,
        column: [{
          label: "项目名称",
          prop: "name",
          formslot: true,
          disabled: false,
          span: 20,
          placeholder: "等待生成项目名称",
          rules: [{
            required: true,
            message: "请选择卖方",
            trigger: "change"
          }]
        }]
      },
      selectionList: [],
      checkUserList: [],
      checkdepartment: [],
      searchForm: {},
      // filterSearchForm: {},
      files: '',
      drawer: false,
      filterConfig: factoringFilterConfig(this.selectDeptClick, this.selectPersonClick),
      tableConfig: factoringTableConfig(this.getMoney),
      sortOption: '',
      optionColumn: {},
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10
      }
    }
  },
  components: {
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    CommonSelect,
    ExportData
  },
  computed: {
    ...mapGetters(["userInfo",'permission']),
  },
  mounted() {
    this.sortOption = this.tableConfig.column
    this.queryTableData()
  },
  methods: {
    summaryMethod({ columns, data }) {
        const sums = [];
        if (columns.length > 0) {
            columns.forEach((column, index) => {
                if([6].includes(index)) {
                    let values = 0;
                    data.map(
                    (item) =>
                        (values =floatAdd(values,Number(item[column.property])) )
                    );
                    sums[index] = `${this.getMoney(values.toFixed(2))}元`;
                }else {
                    sums[index] = "-";
                }
            });
        }
        return sums;
    },    
    setProjectInfo(data) {
      window.sessionStorage.setItem('buildProjectInfo',JSON.stringify(data))
      // 跳转到详情
      this.$router.push({
        path: "/factoring/buildProject/addProject/0",
      })      
    },
    
    goDetail(row) {
      if(!this.permission.buildProject_view){
        this.$message.error("没有查看权限");
        return
      }
      this.$router.push({
        path: `/factoring/buildProject/projectDetail/${row.id}`,
      })
    },

    selectionChange(list) {
      this.selectionList = list
    },
    
    cloudTages(data) {
      this.searchForm = data
    },

    saveData(row) {
      this.$refs.cloudtage.save(row);
    },

    selectDeptClick() {
      this.$refs.selectdepartment.showModel();
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      this.searchForm.managerUser = ids.join(',')
      this.searchForm.managerUserName = people.join(',')
    },

    // 部门 获取
    setDepartment(data = []) {
      this.checkdepartment = data;
      let titleList = data.map((item) => {
        return item.title || item.fullName;
      });
      let ids = data.map((item) => {
        return item.key;
      });

      this.searchForm.managerDeptName = titleList.join(",")
      this.searchForm.managerDeptId = ids.join(",")
    }, 
    
    filterSearch(str, done) {
      this.page.currentPage = 1
      this.queryTableData()
      this.drawer = false
      done()
    },

    searchResetScreen() {
      this.searchForm = {}
      this.page.currentPage = 1
      this.queryTableData()
    },

    searchReset() {
      this.searchForm = {
        auditStatusStr: "",
        name: "",
        projectStatus: "",
        sellerCustName: "",        
      }
      this.page.currentPage = 1
      this.queryTableData()
    },

    searchChange(str, done) {
      this.queryTableData()
      done()
    },

    sortChange() {},

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
      }
      let res = await getFactoringList(params)
      if(res.data.code == 200) {
        this.tableData = res.data.data.records
        this.page.total = res.data.data.total
      }else {
        this.$message.error(res.data.msg)
      }
    },

    handleAdd() {
      this.buildVisible = true
      // this.$router.push({
      //   path: "/factoring/buildProject/addProject"
      // })
    },

    handleEdit() {
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行编辑')
      }else if(this.selectionList.length == 1){
        let data = this.selectionList[0]
        this.$router.push({
          path: `/factoring/buildProject/projectDetail/${data.id}`,
        })
      }else{
        this.$message.error('请选择一条数据进行编辑')
      }
    },

    async handleDelete() {
      let self = this
      let startDelete = () => {
        self.$confirm('确定删除选择的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          self.deleteData()
        }).catch(() => {
          self.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
      if(this.selectionList.length > 1){
        this.$message.error('只能选择一条数据进行删除')
      } else if(this.selectionList.length == 1){
        if(this.selectionList[0].managerUser == this.userInfo.user_id || this.selectionList[0].assistUser == this.userInfo.user_id){
          let data = this.selectionList[0]
          if(data.flowableId != '' && data.auditStatus == 1) {
            // 获取流程数据
            await this.queryFlowData(data.flowableId)
            let presentFlow = this.flowData[this.flowData.length - 1]
            if(this.processDetail.flow[2].historyActivityId == presentFlow.historyActivityId) {
              startDelete()
            }else {
              this.$message.error('流程审批中不能删除')
            }
          }else {
            // 直接弹框提示
            startDelete()
          }
        } else {
          this.$message.error('您没有权限删除此条数据')
        }
      }else{
        this.$message.error('请选择数据进行删除')
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id
      })
      let res = await deleteFactoring({ids: ids.join(',')})
      if(res.data.code == 200){
        this.$message.success('删除成功')
        // 刷新列表
        this.queryTableData()
      }
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
     let page = this.page;
      let data = {
        export: value.code,
        auditState: 1
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplate("/api/bl/blproject/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },

    openFilter() {
      // 回显界面的筛选选项
      // this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
  }
}
</script>
<style lang="scss" scoped>
.factoring-buildProject-container {
  /deep/.el-table .cell  {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .project-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name{
    // overflow: hidden;
    white-space: normal;
    // text-overflow: ellipsis;
    color: #409EFF;
  }
  .project-name:hover{
    color: #409EFF;
    cursor: pointer;
  }
}
.none-border {
  border: 0;
  background-color: transparent !important;
}
</style>
<style lang="scss">
.factoring-buildProject-container {
  .el-table__fixed, .el-table__fixed-right {
    height: calc(100% - 51px) !important;
  }
  .el-table__fixed-footer-wrapper{
    display: none !important;
  }
}
</style>